import React from "react";
import { CloseIcon } from "assets/svgs";
import { useAppSelector } from "store/hooks";
import { userSettingState } from "store/selectors";
import styles from "./styles.module.css";

export function FilterTag({ label, value, onClick }: any) {
  const { isDarkMode } = useAppSelector(userSettingState);
  return (
    <div className={`${styles.filterTag} ${isDarkMode ? styles.darkMode : ""}`}>
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>{value}</div>
      <CloseIcon onClick={onClick} />
    </div>
  );
}
